module.exports = __webpack_public_path__ + "img/Lisa.6bb29477.jpg";